<template>
  <overview-layout ref="overview" :tableCfg="tableCfg">
    <template slot="AdvancedFilter">
      <b-form ref="form" class="offset-md-1" autocomplete="off">
        <div class="row">
          <detail-field label="Student" field="student_id" :optionListApiUrl="'/students/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
          <detail-field label="User" field="user_id" :optionListApiUrl="'/users/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
          <detail-field label="Event Type" field="eventtype_id" :optionListApiUrl="'/logging_types/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
          <detail-field label="Event Time" field="eventtime_date_range" type="daterange" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
        </div>
      </b-form>
    </template>
  </overview-layout>
</template>

<script>
import OverviewMixin from '../../components/OverviewMixin'
import FieldDefs from './FieldDefs.js'

export default {
  name: 'user_overview',
  mixins: [OverviewMixin],
  data () {
    return {
      tableCfg: FieldDefs
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// Overview.vue?c90d12b2